// Каталогът на елементите: икона, i18n ключ и цветовете им от дизайна. Всеки
// цвят е семантичен токен `schema-*` в src/index.css (светла + тъмна стойност).

import type {
  ElementKind,
  ElementSize,
  ObjectKind,
  TableShape,
} from "../../api/restaurantSchema";
import {
  BarIcon,
  DjIcon,
  EntranceIcon,
  PlantIcon,
  StageIcon,
  TableIcon,
  WallIcon,
} from "./schemaIcons";

export interface ElementStyle {
  labelKey: string;
  Icon: React.ComponentType<{ className?: string; strokeWidth?: number }>;
  // Иконата в лентата за добавяне (само мастилото).
  iconClass: string;
  // Чипът в списъка и в инспектора: тинта + мастило.
  chipClass: string;
  // Самият обект върху платното: фон, контур, мастило.
  bodyClass: string;
}

export const ELEMENT_STYLES: Record<ElementKind, ElementStyle> = {
  table: {
    labelKey: "restaurantSchema.kinds.table",
    Icon: TableIcon,
    iconClass: "text-brand-deep-ink",
    chipClass: "bg-brand-tint text-brand-deep-ink",
    bodyClass: "bg-surface border-schema-table-edge text-ink",
  },
  bar: {
    labelKey: "restaurantSchema.kinds.bar",
    Icon: BarIcon,
    iconClass: "text-schema-bar-ink",
    chipClass: "bg-schema-bar text-schema-bar-ink",
    bodyClass: "bg-schema-bar border-schema-bar-edge text-schema-bar-ink",
  },
  wall: {
    labelKey: "restaurantSchema.kinds.wall",
    Icon: WallIcon,
    iconClass: "text-body",
    chipClass: "bg-fill-2 text-body",
    bodyClass: "bg-schema-wall",
  },
  plant: {
    labelKey: "restaurantSchema.kinds.plant",
    Icon: PlantIcon,
    iconClass: "text-schema-plant-ink",
    chipClass: "bg-schema-plant text-schema-plant-ink",
    bodyClass: "bg-schema-plant border-schema-plant-edge text-schema-plant-ink",
  },
  entrance: {
    labelKey: "restaurantSchema.kinds.entrance",
    Icon: EntranceIcon,
    iconClass: "text-schema-entrance-ink",
    chipClass: "bg-schema-entrance text-schema-entrance-ink",
    bodyClass: "bg-schema-entrance border-schema-entrance-edge text-schema-entrance-ink",
  },
  stage: {
    labelKey: "restaurantSchema.kinds.stage",
    Icon: StageIcon,
    iconClass: "text-schema-stage-ink",
    chipClass: "bg-schema-stage text-schema-stage-ink",
    bodyClass: "bg-schema-stage border-schema-stage-edge text-schema-stage-ink",
  },
  dj: {
    labelKey: "restaurantSchema.kinds.dj",
    Icon: DjIcon,
    iconClass: "text-schema-dj-ink",
    chipClass: "bg-schema-dj text-schema-dj-ink",
    bodyClass: "bg-schema-dj border-schema-dj-edge text-schema-dj-ink",
  },
};

// Редът в лентата за добавяне и в групите на списъка (както в дизайна).
export const OBJECT_KINDS: ObjectKind[] = [
  "bar",
  "wall",
  "plant",
  "entrance",
  "stage",
  "dj",
];

export const ELEMENT_SIZES: ElementSize[] = ["small", "medium", "large", "xl"];
export const TABLE_SHAPES: TableShape[] = ["round", "square", "rectangle"];

// Бързите бутони за брой места (инспектор / нова маса).
// 1 = маса за един (напр. на бара).
export const INSPECTOR_SEAT_CHIPS = [1, 2, 4, 6, 8];
export const CREATE_SEAT_CHIPS = [1, 2, 4, 6, 8, 10];

// Стъпката на завъртане (лентата над елемента, инспекторът, клавиш R).
export const ROTATE_STEP = 45;
